import { useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  selectedWorkCompanyState,
  workFormStepState,
} from "store/document/workDocument";

interface UseInitWorkDocTagsProps {
  tempDocumentUuid?: string;
  documentClassUuid?: string;
}

const useInitWorkDocTags = ({
  tempDocumentUuid,
  documentClassUuid,
}: UseInitWorkDocTagsProps) => {
  // Recoil 상태 값
  const selectedCompanyTag = useRecoilValue(selectedWorkCompanyState);

  /* 문서 등록 페이지 스텝 */
  const setWorkFormStep = useSetRecoilState(workFormStepState);

  /* 선택 항목 검사 */
  useEffect(() => {
    if (!selectedCompanyTag && !tempDocumentUuid) return setWorkFormStep(0);
    if (!documentClassUuid && !tempDocumentUuid) return setWorkFormStep(0);
  }, []);
};

export default useInitWorkDocTags;
